import React, { useEffect, useState } from "react";
import { Approval, CardsRenderer, CardsWrapper, Toast } from "../../../../Components";
import { apis, get } from "../../../../Utils/axios";

function ApprovalGroup({ items, loading, emptyLabel, onReload }) {
	return (
		<CardsWrapper loading={loading} cols={1} className="mt-4 max-h-[20rem] overflow-y-auto">
			<CardsRenderer items={items} emptyLabel={emptyLabel} render={(approval) => <Approval key={approval.id} {...approval} onReload={onReload} />} />
		</CardsWrapper>
	);
}

function ApprovalTasks({ type = "flight" }) {
	const [ApprovalsToday, setApprovalsToday] = useState([]);
	const [Loading, setLoading] = useState(true);

	useEffect(() => {
		fetchApprovals();
	}, []);

	const fetchApprovals = () => {
		setLoading(true);
		get(apis.getTodaysApprovals, {}, (r, e) => {
			if (r) {
				setApprovalsToday(r.approvals || []);
				setLoading(false);
			} else if (e) {
				Toast.handleError(e);
				setLoading(false);
			}
		});
	};

	const flights = ApprovalsToday.filter((approval) => approval.type === "flight");
	const expenses = ApprovalsToday.filter((approval) => approval.type === "expense");

	const items = type === "expense" ? expenses : flights;
	const emptyLabel = type === "expense" ? "No expense approvals arrived today" : "No flight approvals arrived today";

	return (
		<div>
			<h3 className="mt-8">Today's Approvals</h3>
			<ApprovalGroup items={items} loading={Loading} emptyLabel={emptyLabel} onReload={fetchApprovals} />
		</div>
	);
}

export default ApprovalTasks;
